<template>
  <footer>
    <div class="container-fluid footer">
      <div class="row">
        <div class="col-sm">
          <span class="copy">&copy; {{ year }} Food Delights</span>
          <b-link :to="{ name: 'help' }">Help</b-link>
          <b-link :to="{ name: 'privacy' }">Privacy</b-link>
          <b-link :to="{ name: 'terms' }">Terms</b-link>
          <b-link :to="{ name: 'about' }">About</b-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import moment from "moment";

export default {
  name: "Footer",
  computed: {
    year() {
      return moment().format("YYYY");
    }
  }
};
</script>

<style scoped>
.footer {
  padding: 15px 16px !important;
  color: #9e9e9e;
  background-color: #424242;
  line-height: 36px;
}

.footer a {
  color: #9e9e9e;
  font-weight: 500;
  margin-right: 16px;
}

.copy {
  color: white;
  margin-right: 16px;
}
</style>
